import React, { PropsWithChildren } from 'react';
import { StyledContent } from './styled';
import { ModuleContainer } from '../../../ModuleContainer';

export const Layout = ({ children }: PropsWithChildren) => {
    return (
        <ModuleContainer spacingTop="none" spacingBottom="large" hasGutter="sm">
            <StyledContent>{children}</StyledContent>
        </ModuleContainer>
    );
};
